import { createBrowserRouter } from "react-router";
import RootLayout from "../../_layouts/RootLayout";
import ErrorPage from "./ErrorPage";
import PrivateRoute from "./PrivateRoute";
import RouteErrorBoundary from "./RouteErrorBoundary";
import { appRoutes } from "./app.routes";
import { authRoutes } from "./auth.routes";
import { miscRoutes } from "./misc.routes";
import { settingsRoutes } from "./settings.routes";

export const router = createBrowserRouter([
    {
        element: <RootLayout />,
        errorElement: <RouteErrorBoundary />,
        children: [
            ...authRoutes,
            {
                path: "",
                element: <PrivateRoute />,
                children: [
                    ...miscRoutes,
                    ...appRoutes,
                    ...settingsRoutes,
                ]
            },
            { path: "*", element: <ErrorPage /> }
        ]
    }
]);
